import {Injectable} from '@angular/core';
import {isImage, isText} from '../../diagram-render/helpers/shapes-detectors.util';
import {ImageCommands} from '../../commands/image/image.commands';
import {TextCommands} from '../../commands/text/text.commands';
import {UndoService} from '../../commands/undo.service';

@Injectable()
export class VertexLinkService {
  constructor(
    private imageCommands: ImageCommands,
    private textCommands: TextCommands,
    private undoSvc: UndoService
  ) {}

  updateCellJson(cell, modifications) {
    const cellJson = cell.getJson();

    if (isImage(cell)) {
      return this.updateImage(cellJson, modifications);
    } else if (isText(cell)) {
      return this.updateText(cellJson, modifications);
    }
  }

  updateText(json, mod) {
    const command = this.textCommands.changeText(json, mod);

    this.undoSvc.executeCommand(command);
  }

  updateImage(json, mod) {
    const command = this.imageCommands.changeImage(json, mod);

    this.undoSvc.executeCommand(command);
  }
}
